import Icon from '../ui/Icon';

// Stand-in for photography that has not been shot yet.
//
// Deliberately looks unfinished — a labelled, dashed frame rather than a
// grey box or a stock photo. A neutral placeholder tends to survive to
// production because nobody notices it is still there; this one says what
// belongs in the slot and cannot be mistaken for a finished image.
//
// Drop in a real photo by passing `src`; everything else stays put.
export default function PhotoSlot({
  src, alt = '', label, hint, className = '', labelIcon = 'user', labelSide = 'left',
  loading = 'lazy',
}) {
  return (
    <div className={`group relative overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black/5 ${className}`}>
      {src ? (
        <img src={src} alt={alt} loading={loading} className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 bg-[repeating-linear-gradient(135deg,#faf3ee_0px,#faf3ee_10px,#f3e6dc_10px,#f3e6dc_20px)] p-4 text-center">
          <span className="rounded-lg border-2 border-dashed border-primary-300 px-3 py-2">
            <Icon name="camera" className="mx-auto h-5 w-5 text-primary-400" />
          </span>
          {hint && (
            <span className="text-[11px] font-medium uppercase tracking-wide text-primary-400">
              {hint}
            </span>
          )}
        </div>
      )}

      {/* The little white pill that names who is in the frame */}
      {label && (
        <span className={`absolute bottom-3 ${labelSide === 'right' ? 'right-3' : 'left-3'} inline-flex items-center gap-1.5 rounded-lg bg-white/95 px-2.5 py-1.5 text-xs font-semibold text-gray-800 shadow-sm backdrop-blur`}>
          <Icon name={labelIcon} className="h-3.5 w-3.5 text-primary-500" />
          {label}
        </span>
      )}
    </div>
  );
}
